export const RECRUITING_VIDEOS_ENDPOINT = '/v1/cpp/recruiting-videos';
export const RECRUITING_VIDEOS_ORDER_ENDPOINT = '/v1/cpp/recruiting-videos/order';
export const MAX_VIDEOS = 4;
export const TITLE_MAX_LENGTH = 50;
export const DESCRIPTION_MAX_LENGTH = 150;
export const URL_PLACEHOLDER = 'Paste a YouTube, Vimeo, or Hudl link';
export const ALLOWED_VIDEO_HOSTS = ['youtube.com', 'youtu.be', 'vimeo.com', 'hudl.com'];
